import { render, staticRenderFns } from "./ContactInfoForm.vue?vue&type=template&id=2a6fa146&scoped=true"
import script from "./ContactInfoForm.vue?vue&type=script&lang=js"
export * from "./ContactInfoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a6fa146",
  null
  
)

export default component.exports